import { MetaDataLink } from "../../models/pagination";
import PaginationBarArrow from "./PaginationBarArrow";
import classNames from "../../helpers/classNames";

interface Props {
  link: MetaDataLink;
  currentPage: number;
  lastPage: number;
  onPageChange: (page: number) => void;
}

// One entry of the server-side pagination bar: an arrow, a page number, or
// the "..." gap (url null). Tailwind only — see PaginationBar.
const ITEM_CLASS = "text-sm px-1.5 mx-0.5";

function PaginationBarItem({
  link,
  onPageChange,
  currentPage,
  lastPage,
}: Props) {
  const { url, label, active } = link;

  const clickhandler = (value: string) => {
    onPageChange(parseInt(value));
  };

  if (label.includes("&laquo;")) {
    return currentPage === 1 ? null : (
      <PaginationBarArrow
        direction="left"
        clickHandler={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
      />
    );
  } else if (label.includes("&raquo;")) {
    return currentPage === lastPage ? null : (
      <PaginationBarArrow
        direction="right"
        clickHandler={() => onPageChange(currentPage + 1)}
        disabled={currentPage === lastPage}
      />
    );
  } else if (url === null) {
    return <div className={ITEM_CLASS}>{label}</div>;
  } else {
    return (
      <button
        className={classNames(
          ITEM_CLASS,
          // Active page: a notch bigger, bold, brand green (#3e5902 = --groen).
          active && "text-lg font-semibold text-[#3e5902]"
        )}
        onClick={() => clickhandler(label)}
      >
        {label}
      </button>
    );
  }
}

export default PaginationBarItem;
